import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ODS from '@ods/ods' // eslint-disable-line
import i18n from './lang/i18n.js' // eslint-disable-line
import { closest } from './utils/ie' // eslint-disable-line
import { truncate, formatDate, formatDateLocale, toCurrency, toCurrencyCode, formatAccount } from './utils/filters' // eslint-disable-line 
import { Drawer } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@ods/ods/lib/theme-onesait/index.css'
import '@/assets/scss/main.scss'
import 'element-ui/lib/theme-chalk/display.css'

import store from './store/store.js'

Vue.config.productionTip = false

closest()

Vue.filter('truncate', truncate)
Vue.filter('formatDate', formatDate)
Vue.filter('formatDateLocale', formatDateLocale)
Vue.filter('toCurrency', toCurrency)
Vue.filter('toCurrencyCode', toCurrencyCode)
Vue.filter('formatAccount', formatAccount)

Vue.use(ODS, { i18n: (key, value) => i18n.t(key, value) })
Vue.use(Drawer, { zIndex: 3005 })

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
